import { postEvents } from '@rmc/webcx-web-libs';
import { VERSION, API_URL_WEBCX } from '../../../../../config';

type ErrorFuncType<EventType> = (
	e: unknown,
	variables: {
		eventType: EventType;
		campaignId: string;
		contentId: string;
		url?: string;
		replacementId?: string;
		selector?: string | null;
		impressionId?: string;
	}
) => void;

type PopupsApiCreateType<EventType> = {
	clientId: string;
	sessionId: string;
	userId: string;
	domainScopedSessionId: string;
	body?: object;
	previewQuery?: object;
	onError?: ErrorFuncType<EventType>;
};

export function useEventsApiPostEvent<EventType>({
	clientId = '',
	sessionId = '',
	userId = '',
	domainScopedSessionId = '',
	previewQuery = {},
	onError = () => {},
}: PopupsApiCreateType<EventType>) {
	// NOTE: useMutation triggers extra rerenders
	// TODO: rewrite to useQuery or useMutate
	return async ({
		eventType,
		campaignId,
		contentId,
		replacementId,
		impressionId,
		selector,
		url,
	}: {
		eventType: EventType;
		campaignId: string;
		contentId: string;
		replacementId?: string;
		impressionId?: string;
		url?: string;
		selector?: string | null;
	}) => {
		const opts: {
			campaignId: string;
			contentId: string;
			url?: string;
			replacementId?: string;
			impressionId?: string;
			selector?: string | null;
		} = {
			campaignId,
			contentId,
			url,
			impressionId,
		};

		const replacementOpts = replacementId ? { replacementId, selector } : {};

		try {
			const data = await postEvents({
				clientId,
				version: VERSION,
				sessionId,
				userId,
				domainScopedSessionId,
				eventType,
				opts: { ...opts, ...replacementOpts },
				previewQuery,
				apiUrlConfig: API_URL_WEBCX,
			});

			return data;
		} catch (e) {
			onError(e, {
				eventType,
				campaignId,
				contentId,
				url,
				replacementId,
				selector,
				impressionId,
			});

			return null;
		}
	};
}
